import { createAction } from '@anm/helpers/saga/typesafe-actions';

import { AppMetaState } from './types';

export const update = createAction('wave.video/appMeta/UPDATE')<
  Partial<AppMetaState>
>();
